import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../utils/axios';
import notificationPoller from '../../utils/notificationPoller';
import {
  FETCH_MESSAGES_REQUEST,
  FETCH_MESSAGES_SUCCESS,
  FETCH_MESSAGES_FAILURE,
  FETCH_UNREAD_COUNT_REQUEST,
  FETCH_UNREAD_COUNT_SUCCESS,
  MARK_MESSAGE_READ_REQUEST,
  MARK_MESSAGE_READ_SUCCESS,
  MARK_ALL_READ_REQUEST,
  MARK_ALL_READ_SUCCESS,
  START_NOTIFICATION_POLLER,
  STOP_NOTIFICATION_POLLER,
  fetchUnreadCountRequest,
  fetchMessagesRequest
} from './actions';

// Fetch messages
function* fetchMessagesSaga() {
  try {
    const { data } = yield call(axiosInstance.get, '/backend/messages/');
    // Extraer los results de la respuesta paginada
    const messages = data.results || data;
    yield put({ type: FETCH_MESSAGES_SUCCESS, payload: messages });
  } catch (error) {
    yield put({ type: FETCH_MESSAGES_FAILURE, payload: error.message });
  }
}

// Fetch unread count
function* fetchUnreadCountSaga() {
  try {
    const { data } = yield call(axiosInstance.get, '/backend/messages/unread_count/');
    yield put({ type: FETCH_UNREAD_COUNT_SUCCESS, payload: data });
  } catch (error) {
    // Silent fail - no critical
  }
}

// Mark message as read
function* markMessageReadSaga(action) {
  try {
    const { messageId } = action.payload;
    const { data } = yield call(axiosInstance.post, `/backend/messages/${messageId}/mark_read/`);

    yield put({ type: MARK_MESSAGE_READ_SUCCESS, payload: data });
    yield put({ type: FETCH_UNREAD_COUNT_REQUEST });
  } catch (error) {
    // Error marking message as read
  }
}

// Mark all as read
function* markAllReadSaga() {
  try {
    yield call(axiosInstance.post, '/backend/messages/mark_all_read/');
    yield put({ type: MARK_ALL_READ_SUCCESS });
    yield put({ type: FETCH_MESSAGES_REQUEST });
  } catch (error) {
    // Error marking all as read
  }
}

// Start notification poller
function* startNotificationPollerSaga(action) {
  try {
    const { interval } = action.payload;

    // Obtener referencia al store dispatch
    // Usamos una función auxiliar para evitar importar store directamente
    const pollCallback = () => {
      // Verificar que el usuario sigue autenticado
      const token = localStorage.getItem('access');
      if (!token) {
        notificationPoller.stop();
        return;
      }

      // Disparar acción SOLO para obtener contador de mensajes sin leer
      // NOTE: NO disparamos fetchUnreadCountRequest() de alertas aquí
      // Las alertas tienen su propio sistema de monitoreo en useAlertNotifications
      // que no depende de polling automático
      if (window.__REDUX_STORE__) {
        window.__REDUX_STORE__.dispatch(fetchUnreadCountRequest());
      }
    };

    // Iniciar el poller
    yield call([notificationPoller, notificationPoller.start], pollCallback, interval);
  } catch (error) {
    // Error starting notification poller
  }
}

// Stop notification poller
function* stopNotificationPollerSaga() {
  try {
    yield call([notificationPoller, notificationPoller.stop]);
  } catch (error) {
    // Error stopping notification poller
  }
}

// Root saga
export function* messagesSaga() {
  yield takeLatest(FETCH_MESSAGES_REQUEST, fetchMessagesSaga);
  yield takeLatest(FETCH_UNREAD_COUNT_REQUEST, fetchUnreadCountSaga);
  yield takeEvery(MARK_MESSAGE_READ_REQUEST, markMessageReadSaga);
  yield takeLatest(MARK_ALL_READ_REQUEST, markAllReadSaga);
  yield takeLatest(START_NOTIFICATION_POLLER, startNotificationPollerSaga);
  yield takeLatest(STOP_NOTIFICATION_POLLER, stopNotificationPollerSaga);
}
